import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import request from "../../utils/http";
import toaster from "../../utils/toaster";
import { Spinner } from "baseui/spinner";
import ActionHeader from "../../components/ActionHeader";
import { Button } from "baseui/button";
import ActionBar from "../../components/ActionBar";
import { FormControl } from "baseui/form-control";
import { FieldGrid } from "./FieldGrid";
import { Select } from "baseui/select";

const Container = styled.div``;

const CandidateComplete = () => {
	const navigate = useNavigate();
	const urlParams = useParams() as any;

	const [candidateId, setCandidateId] = useState("");

	const [allocatedTo, setAllocatedTo] = useState<any>([]);

	const [data, setData] = useState(null as any);

	const [loaded, setLoaded] = useState(false);

	const [adminUsers, setAdminUsers] = useState([] as any);

	const updateUrlParams = async () => {
		setCandidateId(urlParams.candidateId);
	};

	const getCandidate = async () => {
		let result = await request(
			"GET",
			`/api/admin/candidate/${candidateId}`,
			null,
			true,
			false
		);
		if (result.success && result.data?.candidateId) {
			setData(result.data);

			setLoaded(true);
		} else {
			toaster.error("Unable to access candidate");
		}
	};

	const getAdminUsers = async () => {
		let result = await request(
			"GET",
			`/api/admin/utility/admin-users`,
			null,
			true,
			false
		);
		if (result.success && result.data?.users) {
			setAdminUsers(result.data.users);
		} else {
			toaster.error("Unable to load admin users");
		}
	};

	const reallocate = async () => {
		if (allocatedTo.length !== 1) {
			toaster.error("You must select a new allocation");
		} else {
			let result = await request(
				"POST",
				`/api/admin/candidate-action/reallocate`,
				{
					candidateId: candidateId,
					allocateTo: allocatedTo[0].id,
				},
				true,
				false
			);

			navigate(`/candidate/${candidateId}`);
		}
	};

	useEffect(() => {
		if (candidateId != "") {
			getCandidate();
		}
		getAdminUsers();
	}, [candidateId]);

	useEffect(() => {
		updateUrlParams();
	}, [urlParams, updateUrlParams]);

	return (
		<Container>
			{!loaded && (
				<div>
					<Spinner />
				</div>
			)}
			{loaded && data && (
				<>
					<ActionHeader>
						<h1>
							Reallocate {data.fields["Candidate.FirstName"]}{" "}
							{data.fields["Candidate.LastName"]}
						</h1>
						<ActionBar>
							<Button
								kind="secondary"
								onClick={() => {
									navigate(`/candidate/${candidateId}`);
								}}
							>
								Go back
							</Button>
						</ActionBar>
					</ActionHeader>
					<hr />
					<div>
						<FieldGrid>
							<div>
								<FormControl label={"Currently allocated to"}>
									<>{data.allocatedTo.name}</>
								</FormControl>
							</div>
							<div></div>
							<div>
								<FormControl label={"New allocation"}>
									<>
										{adminUsers && (
											<Select
												labelKey={"name"}
												valueKey={"id"}
												options={adminUsers}
												maxDropdownHeight="12rem"
												clearable={false}
												value={allocatedTo}
												onChange={(params) => {
													setAllocatedTo(params.value);
												}}
											/>
										)}
									</>
								</FormControl>
							</div>
						</FieldGrid>
					</div>
					<br />
					<br />
					<div>
						<Button onClick={reallocate}>Reallocate</Button>
					</div>

					<hr />
				</>
			)}
		</Container>
	);
};
export default CandidateComplete;
